import { getLogger } from "@expert/logging";
import { Container, Flex, Text, Title } from "@mantine/core";

import { useEffect } from "react";
import { getRootDispatcher } from "@/analytics";
import { BrokenComputerIcon } from "../Icons";

const logger = getLogger({
    module: "EnrollFailure",
    supportTeam: "sales",
});

export function EnrollFailureScreen({ isProductAsurionBilled }: { isProductAsurionBilled?: boolean }) {
    useEffect(() => {
        logger.error("hit a snag during enrollment");
        void getRootDispatcher().dispatchBusinessEvent("EnrollmentSnagDisplayed");
    }, []);
    return (
        <Flex p="xl" ta="center" direction="column" justify="center" data-testid="sale-finished-view">
            <Container>
                <BrokenComputerIcon />
            </Container>
            <Title
                mt="xxl"
                c="dark.0"
                size="h5"
                fw="var(--mantine-font-weight-heavy)"
                data-testid="sale-view-status-header"
            >
                Hmmm...something went wrong
            </Title>
            <Text c="dark.0" mt="md" size="sm">
                {isProductAsurionBilled
                    ? "We weren’t able to enroll the customer today, but they may be able to try again in the future."
                    : "Don’t worry—we’ll keep trying but there’s a chance it won’t go through."}
            </Text>
        </Flex>
    );
}
